import { AppLayout } from "../shared";
import Alerts from "../Admin/Alerts";

const AdminAlerts_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <Alerts props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default AdminAlerts_layout;
